import { useSelector } from "react-redux";
import {
  ApproveProductComment,
  ProductComment,
  RequestProductComment,
  User,
} from "./type";
import { getLocalized } from "../../../redux/localization";
import { productComments } from "../../../services/urls";
import { Modal } from "../../../components";
import ProductCommentDetail from "./detail";
import { useRef, useState } from "react";
import { ApiResponse, verfiyResponse } from "../../../redux/base/types/saga";
import { BodyType, createRequest } from "../../../redux/base/request";
import { getApiParams } from "../../../redux/auth";
import notify from "devextreme/ui/notify";
import { ApproveProduct } from "../../products/types";
import { Button, DataGrid, ScrollView } from "devextreme-react";
import BaseService from "../../../services";
import CustomStore from "devextreme/data/custom_store";
import { Column } from "devextreme-react/data-grid";

const ProductComments = () => {
  const localize = useSelector(getLocalized);
  const baseService = new BaseService();
  const tableRef = useRef<any>();
  const [show, setShow] = useState(false);
  const [user, setUser] = useState<User>();
  const refData = useRef<ApproveProductComment>({
    productCommentId: "",
    approval: false,
    message: "",
  });
  const newData = useRef<RequestProductComment>({
    productCommentId: "",
  });
  const data = useRef<ProductComment>({
    Id: "",
    ProductCardId: "",
    IsApproved: true,
    Skore: 1,
    Message: "",
    ProductCardName: "",
    UserName: "",
    UserId: "",
    StartDate: "",
    EndDate: "",
    Code: "",
    IsSupplier: true,
    ContractId: "",
    CustomerAccount: {},
    SupplierAccount: {},
  });

  const columns = [
    {
      dataField: "ProductCardName",
      caption: localize.getString("productCardName"),
    },
    {
      dataField: "Skore",
      caption: "Skore",
    },
    {
      dataField: "Message",
      caption: localize.getString("message"),
    },
    {
      dataField: "UserName",
      caption: localize.getString("userName"),
    },
    {
      type: "buttons",
      width: 110,
      buttons: [
        {
          hint: "Detayı göster",
          icon: "info",
          onClick: async (e: any) => {
            data.current = await e.row.data;
            newData.current.productCommentId = data.current.Id;
            refData.current.productCommentId = e.row.data.Id;
            setShow(true);
            const response: ApiResponse<User[]> = await createRequest({
              method: "GET",
              url: "/api/admin/accounts/get-user/" + data.current.UserId,
              bodyType: BodyType.formdata,
              token,
              body: {},
              lang,
            });
            if (verfiyResponse(response)) {
              setUser(response.Result[0]);
            }
          },
        },
      ],
    },
  ];

  const { token, lang } = useSelector(getApiParams);
  return (
    <>
      {" "}
      <Modal
        coverModal={false}
        width={"50%"}
        visible={show}
        onHiding={() => setShow(false)}
        title={localize.getString("productCommentDetail")}
        height={"80%"}
        buttonTitle={localize.getString("save")}
        onSubmitClick={async () => {
          console.log(refData.current);
          const response: ApiResponse<ApproveProduct> = await createRequest({
            method: "POST",
            url: "/api/admin/products/approve-product-comment",
            bodyType: BodyType.raw,
            token,
            body: refData.current,
            lang,
          });
          if (response.Status === 1) {
            notify(response.Message, "success");
            //tableRef.current.instance.refresh();
            setShow(false);
          } else notify(response.Message, "error");
        }}
      >
        <ProductCommentDetail
          data={data.current}
          user={user}
          approveData={refData.current}
        />
      </Modal>
      <div className="dx-card" style={{ backgroundColor: "white" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "start",
            fontSize: "16px",
            fontWeight: 700,
            paddingInline: 10,
            marginBlock: "5px 5px",
          }}
        >
          <p style={{ color: "#434D6E" }}>Onay Bekleyen Yorumlar</p>
          <Button
            hint={"Yenile"}
            icon="refresh"
            type="normal"
            stylingMode="outlined"
            onClick={() => tableRef?.current?._instance?.refresh()}
          />
        </div>
        <div className="grid-div">
          <ScrollView>
            <DataGrid
              ref={tableRef}
              style={{ fontSize: 12 }}
              key="Id"
              className={"custom-data-grid wide-card dashboard-grid"}
              dataSource={
                new CustomStore({
                  key: "Id",
                  //@ts-ignore
                  load: () =>
                    baseService.sendRequest(
                      productComments,
                      "GET",
                      token,
                      "tr-TR"
                    ),
                })
              }
              showBorders
              showRowLines
              showColumnLines={false}
              columnAutoWidth
              columnHidingEnabled
              rowAlternationEnabled
              allowColumnResizing
              allowColumnReordering
              focusedRowEnabled
              grouping={{
                autoExpandAll: false,
              }}
            >
              {columns.map((column, i) => (
                <Column key={i} {...column} />
              ))}
            </DataGrid>
          </ScrollView>
        </div>
      </div>
    </>
  );
};

export default ProductComments;
